// extracted by mini-css-extract-plugin
export default {"changeLink":"oQ-z","disabled":"pQ-z","inline":"qQ-z"};